export const normalizeGetMobileInsurance = (data) => {
  const mobileInsuranceDataNormalized = [];
  if (data && data.length > 0) {
    data.forEach((singleInsurance) => {
      const {
        displays,
        franquicia,
        marca,
        modalidad,
        modelo,
        nombre,
        promo,
        tarifa,
        typeCode,
        typeDescription,
        valor,
        selected,
      } = singleInsurance;
      let displaysNormalized = '';
      if (displays) {
        displaysNormalized = displays;
      }
      let franquiciaNormalized = '';
      if (franquicia) {
        franquiciaNormalized = franquicia;
      }
      let marcaNormalized = '';
      if (marca) {
        marcaNormalized = marca;
      }
      let modalidadNormalized = '';
      if (modalidad) {
        modalidadNormalized = modalidad;
      }
      let modeloNormalized = '';
      if (modelo) {
        modeloNormalized = modelo;
      }
      let nombreNormalized = '';
      if (nombre) {
        nombreNormalized = nombre;
      }
      let promoNormalized = '';
      if (promo) {
        promoNormalized = promo;
      }
      let tarifaNormalized = '';
      if (tarifa) {
        tarifaNormalized = tarifa;
      }
      let typeCodeNormalized = '';
      if (typeCode) {
        typeCodeNormalized = typeCode;
      }
      let typeDescriptionNormalized = '';
      if (typeDescription) {
        typeDescriptionNormalized = typeDescription;
      }
      let valorNormalized = '';
      if (valor) {
        valorNormalized = valor;
      }
      let selectedNormalized = false;
      if (selected) {
        selectedNormalized = selected;
      }

      mobileInsuranceDataNormalized.push({
        displays: displaysNormalized,
        franquicia: franquiciaNormalized,
        marca: marcaNormalized,
        modalidad: modalidadNormalized,
        modelo: modeloNormalized,
        nombre: nombreNormalized,
        promo: promoNormalized,
        tarifa: tarifaNormalized,
        typeCode: typeCodeNormalized,
        typeDescription: typeDescriptionNormalized,
        valor: valorNormalized,
        selected: selectedNormalized,
      });
    });
  }
  return mobileInsuranceDataNormalized;
};

export const normalizeGetMobileInsuranceLegals = (data) => {
  let legalsNormalized = '';
  if (data) {
    legalsNormalized = data;
  }
  return legalsNormalized;
};
